import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import './index.css'

const defaultRegion = 'mex'
const defaultLang = 'es'
const defaultFile = 'terminos-y-condiciones'

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Switch>
        <Route path='/:region/:lang/:filename'>
          <App />
        </Route>
        <Route>
          <Redirect from='/' to={`/${defaultRegion}/${defaultLang}/${defaultFile}`} />
        </Route>
      </Switch>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
)

reportWebVitals()
